import React, { Component } from 'react'
import { Row, Col, Card, Table, Button, Container, Form, Modal } from "react-bootstrap";
import moment from 'moment';



class MaterialDetailsModal extends Component {


    render() {
        const rowData = this.props.stateData.rowData;

        let dateDisplay = false;

        if (rowData != undefined && rowData.length > 0 && rowData[0].delivOrRecvDate != undefined && rowData[0].delivOrRecvDate != "") {
            dateDisplay = true
        }

        return (

            <Modal
                {...this.props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
            >
                <Modal.Header closeButton>
                    <Modal.Title className="modal-title">Material Details</Modal.Title>
                </Modal.Header>
                <Container fluid>
                    <Modal.Body className="p-4">
                        <Row>
                            <Col lg={12} md={12} sm={12} className='mt-3'>
                                <Table className="table  table-bordered table-hover ">
                                    <thead style={{ backgroundColor: "#213046", color: "#ffffff", textAlign: "center" }}>

                                        <tr>
                                            <th>Sno</th>
                                            <th>Material Name</th>
                                            {
                                                dateDisplay ? (
                                                    <th>Date</th>
                                                ) : ("")
                                            }
                                        </tr>
                                    </thead>
                                    <tbody style={{ backgroundColor: "", textAlign: "center" }}>
                                        {rowData
                                            ? rowData.map((item, index) => (
                                                <tr key={index} className="tableBody">
                                                    <td>{index + 1}</td>
                                                    <td>{item.material_name}</td>
                                                    {
                                                        dateDisplay ? (
                                                            <td>{moment.unix(item.delivOrRecvDate).format("DD/MM/YYYY")}</td>
                                                        ) : ("")
                                                    }
                                                </tr>
                                            ))
                                            : ""}
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>



                    </Modal.Body>
                </Container>

            </Modal>

        )
    }
}

export default MaterialDetailsModal